import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=1407dae2&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./taskDetail.vue?vue&type=style&index=1&id=1407dae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407dae2",
  null
  
)

export default component.exports